import React from 'react';
import { Edit, FormTab, TabbedForm, TopToolbar, ListButton, useNotify, useRefresh } from 'react-admin';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import AssetsForm from './AssetsForm';
import CustomToolbar from '../../Components/CustomToolbar';
import { thereWasProblem } from '../../Utils/messages';

const Actions = ({ data }: any) => (
  <TopToolbar>
    <ListButton
      to={`/assets/${data?.id}/show`}
      icon={<ChevronLeft />}
      label='ra.action.back'
    />
  </TopToolbar>
);

const AssetsEdit = (props: any) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const onFailure = (error: any) => {
    refresh();
    notify(
      `${thereWasProblem}: ${error || 'Hubo un error con su solicitud, inténtelo mas tarde...'}`,
      'warning'
    );
  };
  return (
    <Edit title=' ' {...props} actions={<Actions {...props} onFailure={onFailure} />}>
      <TabbedForm
        redirect='show'
        variant='outlined'
        toolbar={<CustomToolbar onFailure={onFailure} />}
      >
        <FormTab label='Bien'>
          <AssetsForm />
        </FormTab>
      </TabbedForm>
    </Edit>
  );
};

export default AssetsEdit;
